package meineglasfaser.frontend.common

import androidx.compose.runtime.Composable
import androidx.compose.runtime.SideEffect
import com.varabyte.kobweb.core.KobwebApp
import kotlinx.browser.document
import meineglasfaser.frontend.common.components.widgets.GlobalBusyIndicator
import meineglasfaser.frontend.common.components.widgets.ToastContainer

@Composable
fun PromKobwebApp(content: @Composable () -> Unit) {
    KobwebApp {
        SideEffect {
            document.querySelector("#_kobweb-root")?.let {
                it.classList.add("body")
            }
        }
        content()
        GlobalBusyIndicator()
        ToastContainer()
    }
}
